// extracted by mini-css-extract-plugin
export default {"tabContainer":"beneficiariesTab_tabContainer__y2L5R","tabHeader":"beneficiariesTab_tabHeader__ngTuL","actionButtonsContainer":"beneficiariesTab_actionButtonsContainer__1SuGI"};